import { render, staticRenderFns } from "./NewAttestation.vue?vue&type=template&id=254fed54&scoped=true"
import script from "./NewAttestation.vue?vue&type=script&lang=js"
export * from "./NewAttestation.vue?vue&type=script&lang=js"
import style0 from "./NewAttestation.vue?vue&type=style&index=0&id=254fed54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254fed54",
  null
  
)

export default component.exports